import React from 'react'
import { Container, Col, Row } from 'reactstrap'

import scaleImg from '../../../assets/scale.png'
import { VideoPlayer } from '../../Utils/GumletVideo'

export const HomePage = () => {
    return (
    <>
        <VideoPlayer videoID="68a1d4509deb1fdadc19badc" />
        <h1 className="mt-5">Welcome to the Job Passion Assessment&trade;</h1>
        
        <p>This is more than just a quiz. It is a guided journey toward discovering what kind 
            of work will bring you energy, fulfillment, and lasting motivation.</p>
        <p>
            This assessment is intended to capture a snapshot of who you authentically
            are at this moment in time—the "True You."
        </p>
        <p>
            You'll see a series of random statements on the following pages. For each statement,
            rate how TRUE they are for you in your life right now, based on the following scale
            from it "Depends" to "Consistently" TRUE:
        </p>

        <Container fluid={true}>
            <Row style={{marginTop: 10, marginBottom: 10}}>
                <Col style={{padding: 0}} xs="12" sm="10" md="8" lg="6"><img className="d-block w-100" src={scaleImg} alt="Rating Scale" /></Col>
                <Col></Col>
            </Row>

        </Container>
        <p>
            There are no right or wrong answers. This assessment is designed to reflect your natural preferences and tendencies.
        </p>
        <div style={{padding: "10px", marginBottom: "20px"}} className="alert-warning">
            <p>TIPS FOR GETTING THE BEST RESULTS:</p>
            <ol>
                <li>
                    Answer based on what feels most typical for you–not what feels ideal.
                </li>
                <li>
                    Answer without considering how your responses might be viewed by others.
                </li>
                
            </ol>
        </div>
        <p>
            You'll be able to see your progress towards completion as you move through the assessment.
            Use the back button if you wish to review or change a response. Then use the continue button
            to move forward again.
        </p>
        <p>
            Typically, you'll need between 20 and 30 minutes to complete this assessment. If you need to
            pause partway through, you can come back later and pick up where you left off because we save
            your responses automatically.
        </p>
        <p>
            As soon as you complete the assessment, you'll get instant access to your results in your
            Job Passion DNA Profile. This report will reveal your Core, Sanctioning, and Character Values
            PLUS the Job Passion Types&trade; that most closely align with those values.
        </p>
        <p>
            Let's get started. Have fun!
        </p>
    </>)
}